import { EventHandlerConfig } from "@/widgetLibrary/interface"

export const DIVIDER_EVENT_HANDLER_CONFIG: EventHandlerConfig = {
  events: [],
  methods: ["setValue", "clearValue"],
}
